export const constant = {
  baseUrl: process.env.REACT_APP_BASE_URL,
};
